<template>
  <div class="provinces-box">
    <!-- 长期居住地 -->
    <div class="product-list-title">
      <div class="product-title-left">
        <template>
          <span class="location-address-icon"></span>
          <span class="location-type">{{!isIssuePlace ? '常住地' : '护照签发地'}} - </span>
          <span class="location">{{provinces[location]}}</span>
        </template>
      </div>
      <div class="product-title-right">
        <div @click="chooseProvince(index)" class="product-right-item" v-for="(province, index) in provinces"
          :class="{active:+index===+location}" :key="index">
          <span>{{province}}</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import pcdService from '@/services/pcd-service';
import utils from '@/libs/utils';
import { mapState, mapActions } from 'vuex';
import User from '@/libs/user';

export default {
  name: 'provinces-box',
  props: {
    isIssuePlace: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Number,
    },
  },
  data() {
    return {
      provinces: {}, // 省份
      location: 0,
      User,
    };
  },
  computed: {
    ...mapState('user', [
      'ipAddress',
    ]),
  },
  methods: {
    ...mapActions('user', [
      'getIPLocation',
    ]),
    // 获取省份
    getProvince() {
      // 获取省份地址
      pcdService.getPcd().then((pcds) => {
        this.pcds = pcds;
        this.provinces = utils.extend({}, pcds[86]);
        this.getIPLocation().then(() => {
          this.getLocation();
        }).catch(() => {
          this.getLocation();
        });

      }).catch((e) => {
        if (e) console.log(e);
      });
    },

    // 获取位置
    getLocation() {
      if (!this.pcds[86]) {
        return;
      }
      if (!this.location && !this.value) {
        if (this.ipAddress && this.ipAddress.province_code) {
          this.location = +this.ipAddress.province_code;
        } else if (User.peer && User.peer.province_code) {
          this.location = +User.peer.province_code;
        }
      } else {
        this.location = +this.value ? +this.value : 440000;
      }
    },

    // 选择省份
    chooseProvince(index) {
      this.location = +index;
    },
  },
  watch: {
    location(newVal) {
      if (newVal) {
        this.$emit('getProvince', this.location);
        this.$emit('input', this.location);
      }
    },
  },
  created() {
    this.getProvince();
  },

};
</script>

<style lang="less" scoped>
.provinces-box{
  border: 1px solid #DEE2E6;
  border-radius: 4px;
  height: 36px;
  padding: 0 30px 0 12px;
  font-size: 14px;
  position: relative;
  background-color: transparent;
  display: flex;
  align-items: center;
  font-size: 14px;
  cursor: pointer;
  &:hover{
    border: 1px solid #599FFF;
    .product-list-title .product-title-right {
      display: block;
    }
  }
  .product-list-title{
    .product-title-left{
      display: flex;
      align-items: center;
      &::after{
        content: '';
        position: absolute;
        top: 50%;
        right: 10px;
        transform: translateY(-50%);
        width: 12px;
        height: 12px;
        background: url(../../assets/imgs/homepage/icon-right-gray.png) no-repeat;
        background-size: 100% 100%;
      }
      .location-address-icon{
        display: inline-block;
        width: 18px;
        height: 18px;
        background: url(../../assets/imgs/homepage/icon-address.png) no-repeat;
        background-size: 100% 100%;
        margin-right: 4px;
      }
      .location-type{
        color: #444;
      }
      .location{
        color: #444;
      }
    }
    .product-title-right{
      display: none;
      color: #000;
      width: 390px;
      height: 185px;
      position: absolute;
      top: 36px;
      right: -1px;
      box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.1);
      border-radius: 4px;
      padding: 20px;
      color: #6f6f6f;
      font-size: 0px;
      background-color: #fff;
      z-index: 1000000;
      text-align: left;
      .product-right-item{
        font-size: 14px;
        display: inline-flex;
        align-items: center;
        justify-content: center;
        width: 50px;
        height: 24px;
        text-align: center;
        border:1px solid transparent;
        margin-bottom: 5px;
        cursor: pointer;
        &:hover{
          border-radius: 12px;
          border: solid 1px #4ba7ee;
          color: #4ba7ee;
        }
      }
      .active{
        color: #4ba7ee;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/provinces-box.vue